







































import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import {
  usersCollection,
  receivedChecklistCollection,
  inventoryCollection,
  Timestamp,
} from "../db";

@Component
export default class EquipmentReceivedChecklist extends Vue {
  @Getter checklistReceived;
  @Getter user;

  private equipmentReceivedChecklistCollection;
  private equipmentReceivedChecklist: any[] = [];

  @Prop({ required: true })
  public item: any;

  private isFirstRun = true;

  async created() {
    this.equipmentReceivedChecklistCollection = inventoryCollection
      .doc(this.item.id)
      .collection("receivedChecklist");

    this.$bind(
      "equipmentReceivedChecklist",
      this.equipmentReceivedChecklistCollection,
      { wait: true }
    ).then(async (list) => {
      // Add records for each checklist item, only once
      if (this.isFirstRun) {
        this.isFirstRun = false;

        for (let i = 0; i < this.checklistReceived.length; i++) {
          const x = this.checklistReceived[i];
          if (!list.some((a) => a.ref != null && a.ref.id == x.id)) {
            await this.equipmentReceivedChecklistCollection.add({
              ref: receivedChecklistCollection.doc(x.id),
              complete: false,
              completeDate: null,
              comments: "",
              user: null,
            });
          }
        }
      }
    });
  }

  orderedList(items) {
    // Vue was freaking out if I sort the array, mapping to new object is hack but it works
    return items
      .filter((x) => typeof(x.ref) == 'object' )
      .map((x) => {
        return {
          id: x.id,
          comments: x.comments,
          complete: x.complete,
          completeDate: x.completeDate,
          text: x.ref.text,
          order: x.ref.order,
          user: x.user ? x.user.displayName : "",
        };
      })
      .sort((a, b) => a.order - b.order);
  }

  async checkChange($event, id) {
    await this.equipmentReceivedChecklistCollection.doc(id).update({
      complete: $event,
      completeDate: $event ? Timestamp.now() : "",
      user: $event ? usersCollection.doc(this.user.id) : "",
    });
  }

  async commentChange($event, id) {
    await this.equipmentReceivedChecklistCollection.doc(id).update({
      comments: $event,
    });
  }

  getFormattedDate(date) {
    const year = date.getFullYear();
    const month = (1 + date.getMonth()).toString();
    const day = date.getDate().toString();
    return month + "/" + day + "/" + year;
  }
}
